module.exports = __webpack_public_path__ + "static/media/mossbrae-paradise.2d11fb0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landscape/mossbrae-paradise.jpg
// module id = 307
// module chunks = 0